var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"page coming-soon"},[_c('div',[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t("global.comingsoon")))]),_c('p',{staticClass:"subtitle"},[_vm._v(_vm._s(_vm.$t("global.subtitle")))]),_c('img',{attrs:{"src":require("@/assets/logo.svg")}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }